import { render } from "./LokasiPo.vue?vue&type=template&id=b67a8210"
import script from "./LokasiPo.vue?vue&type=script&lang=js"
export * from "./LokasiPo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__